<template>
  <div class="plan_item">
    <div class="plan_item_advertisement">
      <!-- <img :src="banner" /> -->
      <img src="https://www.7859888tp.com/750-50.gif" />
    </div>
    <p class="plan_item_title">
      <span style="color: #fbfb06"> 曾道人精英社区</span> 稳杀(十).码
    </p>
    <ul>
      <li v-for="(el, i) in data.list" :key="i" :class="{ li_win: el.ifWin }">
        <span class="qi"
          >{{ el.qiShu }}期: <span style="color: #f606f1">【稳杀(十)码】</span>
        </span>
        <div :class="{}">
          【
          <span
            v-for="(e, i) in el.yuCe"
            :key="e"
            :class="{ win: e === el.code }"
            >{{ e }}</span
          >
          】
        </div>
        <span style="color: #0508e7" v-if="!el.ifZuiXin">
          {{ el.qiShu }}期特码开奖结果：<span style="color: #f90402"
            >{{ el.shengXiao || "??" }}{{ el.code || "??" }}</span
          >
          <span style="color: red">{{ el.ifWin ? "准" : "错" }}</span>
        </span>
      </li>
    </ul>
  </div>
</template>
    
    <script setup>
import top from "@/assets/img/top.gif";
import { toRefs } from "vue";

const origin = window.location.origin;

const props = defineProps({
  data: Object,
});

const { data } = toRefs(props);

data.value.list.forEach((item, index) => {
  if (!item.ifZuiXin) {
    data.value.list[index].codeList = item.shuXingList.slice(2);
    data.value.list[index].boseList = item.shuXingList.slice(0, 2);
  }
});
console.log(data.value, "data.value");
</script>
    
    <style lang="scss" scoped>
.title {
  text-align: center;
  background-color: #009788;
  font-size: 25px;
  font-weight: bold;
  padding: 6px 0;
}
.plan_item {
  border: 1px solid #009788;
  .plan_item_advertisement {
    img {
      width: 100%;
      height: 40px;
      display: block;
    }
  }
  .plan_item_title {
    text-align: center;
    padding: 3px 0;
    border-top: 2px solid #767474;
    border-bottom: 2px solid #767474;
    background: #81007f;
    color: #0def12;
    img {
      width: 30px;
      height: 30px;
    }
  }
  ul {
    background-color: #eee;
    li {
      text-align: center;
      padding: 5px 12px;
      font-weight: bold;
      border-bottom: 1px solid #e4d5be;
      grid-gap: 10px;
      > div {
        display: flex;
        align-items: flex-end;
        // color: ;
        color: #8c2986;
        grid-gap: 6px;
        justify-content: center;
        font-size: 120%;
        margin: 6px 0;
      }
      .win {
        background: #999;
        color: #000;
      }
    }
    .li_win {
      .winText {
        color: #d00880;
      }
    }
    .suck {
      text-decoration-line: line-through;
    }
  }
}
</style>